import { clienteArchivoBancoSemana } from '@/lib/cliente-archivo-banco-semana';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

/** Qué entraría al archivo BAC de la semana para una cuenta de origen (no escribe nada). */
export function useVistaPreviaArchivoSemana(
  semanaId: number | null,
  cuentaBancoOrigen: string,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ['semana', semanaId, 'archivo-banco-bac', cuentaBancoOrigen],
    queryFn: () => clienteArchivoBancoSemana.vistaPrevia(semanaId as number, cuentaBancoOrigen),
    enabled: enabled && semanaId !== null && !!cuentaBancoOrigen,
    // Se vuelve a revisar al abrir y al volver a la pestaña: los pagos se marcan BAC en esta misma pantalla.
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}

/** Genera el .TRF y el .SIN del BN de la semana (no escribe en la base). */
export function useGenerarArchivoBNSemana() {
  return useMutation({
    mutationFn: ({
      semanaId,
      ...body
    }: {
      semanaId: number;
      cuentaBancoOrigen: string;
      transferenciaNo: number;
      fecha: string;
    }) => clienteArchivoBancoSemana.generarBN(semanaId, body),
  });
}

export function useGenerarArchivoSemana() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      semanaId,
      ...body
    }: {
      semanaId: number;
      cuentaBancoOrigen: string;
      planCode: string;
      envioNo: number;
      fecha: string;
    }) => clienteArchivoBancoSemana.generar(semanaId, body),
    onSuccess: (_r, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['semana', variables.semanaId, 'archivo-banco-bac'],
      });
      // El "último envío" de cada cuenta cambia: el diálogo de propuestas también lo sugiere.
      queryClient.invalidateQueries({ queryKey: ['archivo-banco', 'ultimos-por-cuenta'] });
    },
  });
}
